/* Lysverden: type-to-narrow inside long filter groups.
   Delegated from the document because the theme replaces the whole facets
   markup on every filter change — anything bound directly to the inputs would
   be dropped on the first click. */
(() => {
  const INPUT = '[data-lv-facet-search]';
  const ITEM = '.facets__inputs-list-item';

  /* The list is not a fixed sibling of the input: a show-more-component wraps it
     when the group is long. Walk up until we hit the ancestor that holds it. */
  const listScope = (input) => {
    let node = input.parentElement;
    while (node && !node.querySelector(ITEM)) node = node.parentElement;
    return node;
  };

  const normalise = (value) => value.trim().toLowerCase();

  const apply = (input) => {
    const scope = listScope(input);
    if (!scope) return;

    const query = normalise(input.value);
    const items = scope.querySelectorAll(ITEM);

    items.forEach((item) => {
      if (!query) {
        // Hand control back to the theme, including its show-more truncation.
        item.style.removeProperty('display');
        return;
      }

      const label = normalise(item.textContent);
      // 'important' because matches may carry the theme's .hidden class from
      // show-more, which would otherwise keep them collapsed mid-search.
      item.style.setProperty(
        'display',
        label.includes(query) ? 'list-item' : 'none',
        'important'
      );
    });
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.(INPUT);
    if (input) apply(input);
  });

  // Enter inside a facet search must not submit the surrounding filter form.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    if (event.target.closest?.(INPUT)) event.preventDefault();
  });
})();
